<i18n>
{
  "fr": {
    "yes": "Oui",
    "no": "Non"
  },
  "en": {
    "yes": "Yes",
    "no": "No"
  }
}
</i18n>
<template>
  <b-field class="mb-0">
    <b-checkbox-button :value="[value]" native-value="true" type="is-success" @input="handleInput">
      {{ $t('yes') }}
    </b-checkbox-button>
    <b-checkbox-button :value="[value]" native-value="false" type="is-danger" @input="handleInput">
      {{ $t('no') }}
    </b-checkbox-button>
  </b-field>
</template>
<script>
export default {
  props: {
    id: String,
    value: String
  },
  methods: {
    handleInput(values) {
      const value = values[values.length - 1]
      this.$emit('input', value)
      this.$emit('save')
    }
  }
}
</script>